import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import './PrivacyPolicy.css';

/**
 * PrivacyPolicy component - Displays the privacy policy using Termly embed
 * @returns {JSX.Element} The rendered privacy policy page with Termly iframe
 */
const PrivacyPolicy = () => {
  const navigate = useNavigate();

  /**
   * Loads the Termly embed script when component mounts
   */
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';

    const existingScript = document.getElementById('termly-jssdk');
    if (!existingScript) {
      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);
    }

    return () => {
      const scriptToRemove = document.getElementById('termly-jssdk');
      if (scriptToRemove) {
        scriptToRemove.remove();
      }
    };
  }, []);

  /**
   * Handles navigation back to previous page or home
   * @returns {void}
   */
  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="privacy-policy-container">
      <div className="privacy-policy-header">
        <button className="back-button" onClick={handleBack}>
          <FaArrowLeft />
        </button>
        <h1>Privacy Policy</h1>
      </div>
      <div className="privacy-policy-content">
        <div name="termly-embed" data-id="1be06442-538f-4ed6-b509-d3137e94748a"></div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
